exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text[data-v-2c93f5b1] {\n  font-size: 14px;\n}\n.item[data-v-2c93f5b1] {\n  margin-bottom: 1px;\n}\n.clearfix[data-v-2c93f5b1]:before,\n.clearfix[data-v-2c93f5b1]:after {\n  display: table;\n  content: \"\";\n}\n.clearfix[data-v-2c93f5b1]:after {\n  clear: both;\n}\n.box-card[data-v-2c93f5b1] {\n  width: 480px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2c93f5b1","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/member/selfservice/registrationactivityadd.vue
// module id = 1332
// module chunks = 0